// extracted by mini-css-extract-plugin
export default {"manifestEditorModal":"styles-module__manifestEditorModal__P2DBq"};